//import { createStore } from "vuex";
import { reactive, readonly } from "vue";

const state = reactive({
  activeWall: "gross", // "gross" | "klein"
  zweispaltig: false,
  activeApi: "https://ema25-api.pani.cloud",
  //activeSocket: "ws://localhost:9897",
  activeSocket: "wss://ema25-socket.pani.cloud",
  activeWebsocket: new Array(),
  activeWettbewerbe: new Array(
     /*{
     wett: 1,
      name: "Lech 🇦🇹 → Bludenz 🇦🇹",
      name_top3: "TAR TEAM - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
     {
      wett: 11,
      name: "Lech 🇦🇹 → Bludenz 🇦🇹",
      name_top3: "RUN2 - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 21,
      name: "Lech 🇦🇹 → Bludenz 🇦🇹",
      name_top3: "SOLO - TOP3 M/W",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 2,
      name: "Bludenz 🇦🇹 → Brand 🇦🇹",
      name_top3: "TAR TEAM - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 12,
      name: "Bludenz 🇦🇹 → Brand 🇦🇹",
      name_top3: "RUN2 - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 22,
      name: "Bludenz 🇦🇹 → Brand 🇦🇹",
      name_top3: "SOLO - TOP3 M/W",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 3,
      name: "Brand 🇦🇹 → Klosters 🇨🇭",
      name_top3: "TAR TEAM - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 23,
      name: "Brand 🇦🇹 → Klosters 🇨🇭",
      name_top3: "SOLO - TOP3 M/W",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 4,
      name: "Klosters 🇨🇭 → Gotschnagrat 🇨🇭",
      name_top3: "TAR TEAM - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 24,
      name: "Klosters 🇨🇭 → Gotschnagrat 🇨🇭",
      name_top3: "SOLO - TOP3 M/W",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 5,
      name: "Klosters 🇨🇭 → Zernez 🇨🇭",
      name_top3: "TAR TEAM - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 25,
      name: "Klosters 🇨🇭 → Zernez 🇨🇭",
      name_top3: "SOLO - TOP3 M/W",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 6,
      name: "Zernez 🇨🇭 → Scuol 🇨🇭",
      name_top3: "TAR TEAM - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 26,
      name: "Zernez 🇨🇭 → Scuol 🇨🇭",
      name_top3: "SOLO - TOP3 M/W",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 7,
      name: "Scuol 🇨🇭 → Reschensee 🇮🇹",
      name_top3: "TAR TEAM - TOP3 MEN/WOMEN",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 27,
      name: "Scuol 🇨🇭 → Reschensee 🇮🇹",
      name_top3: "SOLO - TOP3 M/W",
      balken: "#F59C23",
      verlauf: "rgb(41, 141, 45)",
    }*/



    /*{
      wett: 1,
      name: "T11 Trail",
      balken: "#1EBBEF",
      verlauf: "rgb(72, 213, 151)",
    },
    {
      wett: 2,
      name: "T54 Trail",
      balken: "#E35351",
      verlauf: "rgb(72, 213, 151)",
    },
    {
      wett: 3,
      name: "T33 Trail",
      balken: "#F7A600",
      verlauf: "rgb(72, 213, 151)",
    },
    {
      wett: 4,
      name: "T24 Trail",
      balken: "#87BD3F",
      verlauf: "rgb(72, 213, 151)",
    },*/
    /*{
      wett: 1,
      name: "Mitteldistanz",
      balken: "#ED1F24",
      verlauf: "rgb(72, 213, 151)",
    },
    {
      wett: 2,
      name: "Mitteldistanz-Staffel",
      balken: "#ED1F24",
      verlauf: "rgb(72, 213, 151)",
    },
     {
      wett: 3,
      name: "Olympische Distanz",
      balken: "#03579C",
      verlauf: "rgb(3, 87, 156)",
    },
    {
      wett: 4,
      name: "Olympische Distanz-Staffel",
      balken: "#03579C",
      verlauf: "rgb(3, 87, 156)",
    },
      {
      wett: 5,
      name: "Sprintdistanz",
      balken: "#FAEE0C",
      verlauf: "rgb(250, 238, 12)",
    },
    {
      wett: 6,
      name: "Sprintdistanz-Staffel",
      balken: "#FAEE0C",
      verlauf: "rgb(250, 238, 12)",
    },*/
    /*
     {
      wett: 1,
      name: "Marathon",
      balken: "#1A4280",
      verlauf: "rgb(215,110,45)",
    },
    {
      wett: 2,
      name: "Team Run",
      balken: "#1A4280",
      verlauf: "rgb(24,59,113)",
    },
    {
      wett: 3,
      name: "Semi-marathon",
      balken: "#1A4280",
      verlauf: "rgb(24,59,113)",
    },
    {
      wett: 4,
      name: "5k Run for Success",
      balken: "#1A4280",
      verlauf: "rgb(24,59,113)",
    },
    {
      wett: 5,
      name: "Minimarathon",
      balken: "#1A4280",
      verlauf: "rgb(24,59,113)",
    },
    {
      wett: 6,
      name: "Mini Minimarathon",
      balken: "#1A4280",
      verlauf: "rgb(24,59,113)",
    },
    {
      wett: 7,
      name: "Roll & Run",
      balken: "#1A4280",
      verlauf: "rgb(24,59,113)",
    },
    {
      wett: 8,
      name: "Unity Run 42",
      balken: "#1A4280",
      verlauf: "rgb(24,59,113)",
    } /*
    /*{
      wett: 1,
      name: "TDE | 100km",
      balken: "#1A4280",
      verlauf: "rgb(26, 66, 128)",
    },
    {
      wett: 2,
      name: "TDE | 45km",
      balken: "#1A4280",
      verlauf: "rgb(26, 66, 128)",
    }*/
        {
      wett: 1,
      name: "Sparkasse Ulm Marathon",
      balken: "#E6E7E8",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 2,
      name: "Beurer Halbmarathon",
      balken: "#A13A5B",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 3,
      name: "ZEISS Marathon Staffel",
      balken: "#204391",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 4,
      name: "Inline Halbmarathon",
      balken: "#007AC2",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 5,
      name: "Häussler Handbike Halbmarathon",
      balken: "#F26521",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 6,
      name: "PERI Power Nordic Walking",
      balken: "#FDC30D",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 7,
      name: "Liqui Moly Citylauf 10km",
      balken: "#0F5BAA",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 8,
      name: "PistenBully Walk 10km",
      balken: "#ED1C24",
      verlauf: "rgb(41, 141, 45)",
    },
    {
      wett: 9,
      name: "AOK Gesundheitslauf 5km",
      balken: "#085F42",
      verlauf: "rgb(41, 141, 45)",
    } 

     /* {
        wett: 10,
        name: "Open Race - Sprintdistanz (AG)",
        balken: "#80eeb3",
        verlauf: "rgb(41, 141, 45)",
      },
      {
        wett: 11,
        name: "Open Race - Staffel Sprintdistanz",
        balken: "#80eeb3",
        verlauf: "rgb(41, 141, 45)",
      },
      {
        wett: 20,
        name: "Open Race - Kurzdistanz (AG)",
        balken: "#80eeb3",
        verlauf: "rgb(41, 141, 45)",
      },
      {
        wett: 21,
        name: "Open Race - Staffel Kurzdistanz",
        balken: "#80eeb3",
        verlauf: "rgb(41, 141, 45)",
      },
      {
        wett: 50,
        name: "Deutsche Meisterschaft Para Triathlon Kurzdistanz",
        balken: "#80eeb3",
        verlauf: "rgb(41, 141, 45)",
      },
      {
        wett: 30,
        name: "WTCS - Elite Männer",
        balken: "#80eeb3",
        verlauf: "rgb(41, 141, 45)",
      },
      {
        wett: 31,
        name: "WTCS - Elite Frauen",
        balken: "#80eeb3",
        verlauf: "rgb(41, 141, 45)",
      },
      {
        wett: 40,
        name: "Elite - Weltmeisterschaft Mixed Relay",
        balken: "#80eeb3",
        verlauf: "rgb(41, 141, 45)",
      }
    */
    //{
    //  wett: 1,
    //  name: "STUBAIER HÖHENWEG",
   //   balken: "#006C8A",
    //},
    //{
    //  wett: 2,
    //  name: "STUBAI ULTRA",
    //  balken: "#2AAFE5",
    //},
    //{
    //  wett: 3,
    //  name: "STUBAI CLASSIC",
    //  balken: "#64222C",
    //},
   // {
   //   wett: 4,
   //   name: "STUBAI EXPRESS",
    //  balken: "#76B828",
    //},
    //{
    //  wett: 5,
    //  name: "STUBAI SUNNENSEIT´N TRAIL",
    //  balken: "#E28D00",
    //}

    //{
    //  wett: 1,
    //  name: "ULTRATRAIL",
    //  balken: "#258D2D",
    //  
    //},
    //{ wett: 2, name: "EHRWALD TRAIL", balken: "#7EB348" },
    //{ wett: 3, name: "LEUTASCH TRAIL", balken: "#007EC7" },
    //{ wett: 4, name: "MITTENWALD TRAIL", balken: "#28BDEF" },
    //{
    //  wett: 5,
    //  name: "GARMISCH-PARTENKIRCHEN TRAIL",
    //  balken: "#556C78",
    //},
    //{
    //  wett: 6,
    //  name: "GRAINAU TRAIL",
    //  balken: "#ACA8A5",
    //},
    //{
    //  wett: 10,
    //  name: "ZUT100",
    //  balken: "#E8412C",
    //}
  ),
  activeSelectedWettbewerbe: new Array(1),
  activeSelectedWettbewerb: 1,
  activeSelectedWettbewerbTyp: new Array(
    {
      variable: "Geschlecht",
      filter: "M",
      name: "TOP 3 MEN",
      value: 1,
      label: "Geschecht M",
    },
    {
      variable: "Geschlecht",
      filter: "W",
      name: "TOP 3 WOMAN",
      value: 2,
      label: "Geschecht W",
    }
  ),
  activeSelectedWettbewerbAG: new Array(
    {
      variable: "---",
      filter: "W",
      name: "---",
      value: 1,
      label: "---",
    }
   
  ),
  activeSelectedWettbewerbTypSelected: null,
  activeSelectedWettbewerbAGSelected: null,
});
const getters = {
  activeWall: () => state.activeWall,
  activeApi: () => state.activeApi,
  activeSocket: () => state.activeSocket,
  activeWebsocket: () => state.activeWebsocket,
  activeWettbewerbe: () => state.activeWettbewerbe,
  activeSelectedWettbewerbe: () => state.activeSelectedWettbewerbe,
  activeSelectedWettbewerb: () => state.activeSelectedWettbewerb,
  activeSelectedWettbewerbTyp: () => state.activeSelectedWettbewerbTyp,
  activeSelectedWettbewerbTypSelected: () => state.activeSelectedWettbewerbTypSelected,
  activeSelectedWettbewerbAG: () => state.activeSelectedWettbewerbAG,
  activeSelectedWettbewerbAGSelected: () => state.activeSelectedWettbewerbAGSelected,
};
const mutations = {
  setWall(view) {
    console.log("STATE: setWall", view);
    state.activeWall = view;
  },
  setWebsocket(view) {
    //console.log("STATE: setWebsocket", view);
    state.activeWebsocket = view;
  },
  setSelectedWettbewerbe(view) {
    console.log("STATE: setSelectedWettbewerbe", view);
    state.activeSelectedWettbewerbe = view;
  },
  setSelectedWettbewerb(view) {
    console.log("STATE: setSelectedWettbewerb", view);
    state.activeSelectedWettbewerb = view;
  },
  setSelectedWettbewerbTyp(view) {
    console.log("STATE: setSelectedWettbewerbTyp", view);
    state.activeSelectedWettbewerbTyp = view;
  },
  setSelectedWettbewerbTypSelected(view) {
    console.log("STATE: setSelectedWettbewerbTypSelected", view);
    state.activeSelectedWettbewerbTypSelected = view;
  },
  setSelectedWettbewerbAG(view) {
    console.log("STATE: setSelectedWettbewerbAG", view);
    state.activeSelectedWettbewerbAG = view;
  },
  setSelectedWettbewerbAGSelected(view) {
    console.log("STATE: setSelectedWettbewerbAGSelected", view);
    state.activeSelectedWettbewerbAGSelected = view;
  },
};

export default {
  state: readonly(state),
  getters,
  mutations,
  actions: {},
  modules: {},
};
